import {ChangeEvent, MouseEvent, useCallback, useEffect, useRef, useState} from "react";

import {debounce} from "@pg-mono/nodash";

import {ISearchInputValue} from "../ISearchInputValue";
import {ISearchAutocompleteInputProps} from "./SearchAutocompleteTypes";

const INPUT_DEBOUNCE_TIME = 300;

export const useSearchAutocompleteInput = (props: ISearchAutocompleteInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [tempLabel, setTempLabel] = useState(props.value.label);

    useEffect(() => {
        props.onInputMount && props.onInputMount(inputRef);
    }, [inputRef]);

    useEffect(() => {
        setTempLabel(props.value.label);
    }, [props.value.label]);

    const onMouseUp = (e: MouseEvent<HTMLInputElement>) => {
        // Safari unselects selected onFocus input value. This solves the problem.
        e.preventDefault();
    };

    const onDebouncedChange = useCallback(
        debounce((e: ChangeEvent<HTMLInputElement>) => {
            const newInputValue: ISearchInputValue = {
                ...props.value,
                label: e.target.value
            };

            props.onChange(props.name, newInputValue);
            props.openDropdown();
        }, INPUT_DEBOUNCE_TIME),
        [props.value]
    );

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setTempLabel(e.target.value);
        onDebouncedChange(e);
    };

    const onDivClick = () => {
        const defaultAction = () => {
            inputRef.current && inputRef.current.focus();
            props.openDropdown();
        };

        if (props.onInputClick) {
            props.onInputClick(defaultAction);
        } else {
            defaultAction();
        }
    };

    const onIconClick = (e: MouseEvent) => {
        e.stopPropagation();
        inputRef.current && inputRef.current.focus();
        props.isDropdownOpen ? props.closeDropdown() : props.openDropdown();
    };

    return {
        inputRef,
        inputValue: props.activeItemLabel || tempLabel || "",
        onChange,
        onDivClick,
        onIconClick,
        onMouseUp
    };
};
import {ChangeEvent, MouseEvent, useCallback, useEffect, useRef, useState} from "react";

import {debounce} from "@pg-mono/nodash";

import {ISearchInputValue} from "../ISearchInputValue";
import {ISearchAutocompleteInputProps} from "./SearchAutocompleteTypes";

const INPUT_DEBOUNCE_TIME = 300;

export const useSearchAutocompleteInput = (props: ISearchAutocompleteInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [tempLabel, setTempLabel] = useState(props.value.label);

    useEffect(() => {
        props.onInputMount && props.onInputMount(inputRef);
    }, [inputRef]);

    useEffect(() => {
        setTempLabel(props.value.label);
    }, [props.value.label]);

    const onMouseUp = (e: MouseEvent<HTMLInputElement>) => {
        // Safari unselects selected onFocus input value. This solves the problem.
        e.preventDefault();
    };

    const onDebouncedChange = useCallback(
        debounce((e: ChangeEvent<HTMLInputElement>) => {
            const newInputValue: ISearchInputValue = {
                ...props.value,
                label: e.target.value
            };

            props.onChange(props.name, newInputValue);
            props.openDropdown();
        }, INPUT_DEBOUNCE_TIME),
        [props.value]
    );

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        setTempLabel(e.target.value);
        onDebouncedChange(e);
    };

    const onDivClick = () => {
        const defaultAction = () => {
            inputRef.current && inputRef.current.focus();
            props.openDropdown();
        };

        if (props.onInputClick) {
            props.onInputClick(defaultAction);
        } else {
            defaultAction();
        }
    };

    const onIconClick = (e: MouseEvent) => {
        e.stopPropagation();
        inputRef.current && inputRef.current.focus();
        props.isDropdownOpen ? props.closeDropdown() : props.openDropdown();
    };

    return {
        inputRef,
        inputValue: props.activeItemLabel || tempLabel || "",
        onChange,
        onDivClick,
        onIconClick,
        onMouseUp
    };
};
